import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

const APP_LINK = /\[([^\]]+)\]\((\/(?!\/)[^)\s]*)\)/g;

export function isStafflyAppPath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('\\') && !path.includes('..');
}

/** Renders assistant text and turns same-app markdown links into routes. */
export function AssistantMessageBody({ text }: { text: string }) {
  const nodes: ReactNode[] = [];
  const pattern = new RegExp(APP_LINK);
  let last = 0;
  let key = 0;
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(text)) !== null) {
    const path = match[2];
    if (!isStafflyAppPath(path))
      continue;
    if (match.index > last)
      nodes.push(text.slice(last, match.index));
    nodes.push(
      <Link key={key++} to={path} className="font-medium text-blue-700 underline">
        {match[1]}
      </Link>,
    );
    last = pattern.lastIndex;
  }
  if (last < text.length)
    nodes.push(text.slice(last));

  return <p className="whitespace-pre-wrap">{nodes}</p>;
}
